export const DISABLED_MAINTENANCE = 'DISABLED_MAINTENANCE'

export const setAppSettings = (value) => ({
  type: DISABLED_MAINTENANCE,
  value,
})
